import { Component, Input } from '@angular/core';

import {
  anyFnExec,
  CellComponent,
  CellContext,
  GridData,
  SelectCellConfig,
  SelectionItem,
} from '../../models';

@Component({
  selector: 'app-select-display',
  template: `<span
    [attr.data-testId]="
      'display-' + context.column.header.name + '-' + context.row.index
    "
    >{{
      (options | findByProperty : 'id' : context.data[context.column.columnDef])
        ?.name ?? ''
    }}</span
  >`,
})
export class SelectDisplayComponent implements CellComponent<GridData> {
  @Input({ required: true }) context!: CellContext<GridData>;

  get config(): SelectCellConfig<GridData> {
    return this.context.config as SelectCellConfig<GridData>;
  }

  get options(): SelectionItem[] {
    return anyFnExec(this.config.options, this.context.data) as SelectionItem[];
  }
}
